export const mockArticles = [
  {
    id: '1',
    title: '某顶流男星深夜私会神秘女子，酒店大堂被拍全程无遮挡',
    slug: 'top-star-secret-date',
    category: 'star-scandal',
    categoryName: '明星翻车现场',
    excerpt: '据知情人士透露，该男星当晚独自驱车前往某五星级酒店，与一名身着黑色长裙的女子在大堂碰面后一同进入电梯。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Celebrity%20scandal%20night%20scene%2C%20luxury%20hotel%20lobby%20with%20dim%20warm%20lighting%2C%20mysterious%20atmosphere%2C%20cinematic%20mood%2C%20paparazzi%20style%20photography%2C%20blurred%20figures%20in%20elegant%20interior%2C%20dark%20tones%20with%20golden%20accents&width=1600&height=900&seq=article-hero-01&orientation=landscape',
    date: '2026-07-07',
    views: '128.9万',
    comments: '3.2万',
    featured: true,
  },
  {
    id: '2',
    title: '当红小花片场耍大牌？剧组工作人员匿名爆料拍摄内幕',
    slug: 'actress-diva-on-set',
    category: 'star-scandal',
    categoryName: '明星翻车现场',
    excerpt: '多名剧组工作人员匿名向本平台爆料，称某当红小花在拍摄期间频繁迟到、对工作人员态度恶劣。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Film%20set%20behind%20scenes%2C%20dramatic%20lighting%2C%20movie%20production%20equipment%20silhouettes%2C%20tense%20atmosphere%2C%20professional%20camera%20and%20lights%2C%20dark%20moody%20cinematography%2C%20warm%20spotlight%20on%20empty%20director%20chair&width=1600&height=900&seq=article-hero-02&orientation=landscape',
    date: '2026-07-06',
    views: '96.3万',
    comments: '2.8万',
    featured: false,
  },
  {
    id: '3',
    title: '知名网红直播带货翻车，被粉丝当场质疑产品虚假宣传',
    slug: 'influencer-livestream-fail',
    category: 'influencer-gossip',
    categoryName: '网红吃瓜',
    excerpt: '该网红在直播间推荐某美容仪器时被粉丝当场对比官方参数，发现宣传功效与实际严重不符。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Livestream%20studio%20setup%20with%20ring%20light%20and%20products%20on%20display%2C%20modern%20streaming%20equipment%2C%20warm%20ambient%20lighting%2C%20dramatic%20shadows%2C%20professional%20beauty%20product%20photography%2C%20clean%20minimalist%20desk%20setup&width=1600&height=900&seq=article-hero-03&orientation=landscape',
    date: '2026-07-06',
    views: '156.7万',
    comments: '5.1万',
    featured: false,
  },
  {
    id: '4',
    title: '某选秀节目黑幕曝光：导师打分存在严重偏向，内部聊天记录流出',
    slug: 'talent-show-rigging',
    category: 'star-scandal',
    categoryName: '明星翻车现场',
    excerpt: '一份疑似节目组内部工作人员的聊天记录近日在网络上疯传，揭示了选秀节目背后的暗箱操作。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Talent%20show%20stage%20with%20dramatic%20spotlight%20and%20empty%20judges%20panel%2C%20theatrical%20atmosphere%2C%20darkened%20auditorium%20with%20stage%20lights%2C%20mysterious%20backstage%20vibe%2C%20red%20velvet%20curtains%2C%20entertainment%20industry%20drama&width=1600&height=900&seq=article-hero-04&orientation=landscape',
    date: '2026-07-05',
    views: '203.4万',
    comments: '8.7万',
    featured: false,
  },
  {
    id: '5',
    title: '网红情侣疑似分手？双方社交账号互相取关引发粉丝热议',
    slug: 'influencer-couple-breakup',
    category: 'influencer-gossip',
    categoryName: '网红吃瓜',
    excerpt: '这对拥有千万粉丝的网红情侣近日被眼尖网友发现互相取关了所有社交平台，且删除了所有合照。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Social%20media%20phone%20screen%20showing%20unfollowed%20profile%2C%20modern%20smartphone%20with%20social%20app%20interface%2C%20dim%20bedroom%20lighting%2C%20emotional%20atmosphere%2C%20warm%20golden%20hour%20light%20through%20curtains%2C%20relationship%20drama%20mood&width=1600&height=900&seq=article-hero-05&orientation=landscape',
    date: '2026-07-05',
    views: '89.2万',
    comments: '4.3万',
    featured: false,
  },
  {
    id: '6',
    title: '知名歌手演唱会假唱实锤？技术分析视频引发全网争议',
    slug: 'singer-lip-sync-exposed',
    category: 'star-scandal',
    categoryName: '明星翻车现场',
    excerpt: '音乐博主发布的技术分析视频显示，该歌手在演唱会上多首歌曲存在对口型嫌疑，引发粉丝与网友激烈争论。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Music%20concert%20stage%20with%20colorful%20lights%20and%20smoke%20effects%2C%20large%20crowd%20silhouettes%2C%20dramatic%20arena%20atmosphere%2C%20spotlight%20on%20empty%20microphone%20stand%2C%20dark%20moody%20concert%20photography&width=1600&height=900&seq=article-hero-06&orientation=landscape',
    date: '2026-07-04',
    views: '267.8万',
    comments: '12.5万',
    featured: false,
  },
  {
    id: '7',
    title: '某品牌代言人突然解约，背后原因竟是品牌方涉嫌辱华言论',
    slug: 'brand-ambassador-cancels',
    category: 'black-material',
    categoryName: '黑料入口',
    excerpt: '该明星工作室凌晨发布声明宣布终止与某国际品牌的所有合作，声明中暗示品牌方存在不当言论。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Press%20conference%20empty%20podium%20with%20microphones%2C%20corporate%20statement%20scene%2C%20dramatic%20lighting%2C%20professional%20business%20setting%2C%20dark%20wood%20podium%2C%20serious%20atmosphere%2C%20high%20contrast%20photography&width=1600&height=900&seq=article-hero-07&orientation=landscape',
    date: '2026-07-04',
    views: '189.3万',
    comments: '7.8万',
    featured: true,
  },
  {
    id: '8',
    title: '综艺节目录制现场发生意外，嘉宾受伤被紧急送医',
    slug: 'variety-show-accident',
    category: 'star-scandal',
    categoryName: '明星翻车现场',
    excerpt: '某热门综艺在户外录制环节中发生意外，一位嘉宾在完成游戏任务时不慎摔倒导致脚踝受伤。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Outdoor%20variety%20show%20set%20with%20obstacle%20course%20equipment%2C%20bright%20daylight%2C%20production%20crew%20silhouettes%2C%20professional%20filming%20setup%2C%20colorful%20inflatable%20obstacles%2C%20summer%20outdoor%20atmosphere%2C%20worried%20crew%20gathering&width=1600&height=900&seq=article-hero-08&orientation=landscape',
    date: '2026-07-03',
    views: '112.4万',
    comments: '3.6万',
    featured: false,
  },
  {
    id: '9',
    title: '网红偷税漏税被查，补缴金额高达千万引行业震动',
    slug: 'influencer-tax-evasion',
    category: 'influencer-gossip',
    categoryName: '网红吃瓜',
    excerpt: '税务部门公布的最新案例中，某头部网红因偷逃税款被依法追缴并处以罚款，合计金额超过千万。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Financial%20documents%20and%20calculator%20on%20modern%20office%20desk%2C%20serious%20business%20atmosphere%2C%20dramatic%20shadows%20from%20window%20blinds%2C%20legal%20investigation%20mood%2C%20professional%20corporate%20setting%2C%20warm%20dark%20tones&width=1600&height=900&seq=article-hero-09&orientation=landscape',
    date: '2026-07-03',
    views: '345.6万',
    comments: '15.2万',
    featured: false,
  },
  {
    id: '10',
    title: '某女星隐婚生子被拍？月子中心出入照片引发全网猜测',
    slug: 'actress-secret-marriage',
    category: 'star-scandal',
    categoryName: '明星翻车现场',
    excerpt: '狗仔队拍到该女星多次出入某高档月子中心，身边还有保姆抱着婴儿，疑似已秘密产子。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Luxury%20residential%20building%20entrance%20with%20paparazzi%20perspective%2C%20telephoto%20lens%20style%2C%20evening%20golden%20light%2C%20urban%20luxury%20setting%2C%20private%20and%20exclusive%20atmosphere%2C%20modern%20architecture%20with%20warm%20lighting&width=1600&height=900&seq=article-hero-10&orientation=landscape',
    date: '2026-07-02',
    views: '278.9万',
    comments: '11.3万',
    featured: false,
  },
  {
    id: '11',
    title: '某知名导演被多名女演员联合举报性骚扰，官方已介入调查',
    slug: 'director-harassment-allegations',
    category: 'black-material',
    categoryName: '黑料入口',
    excerpt: '五位女演员通过律师联合发布声明，指控该导演在片场存在长期性骚扰行为，目前相关部门已启动调查程序。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Film%20director%20chair%20on%20empty%20movie%20set%2C%20dramatic%20lighting%20with%20long%20shadows%2C%20serious%20legal%20atmosphere%2C%20darkened%20soundstage%2C%20professional%20film%20equipment%20in%20background%2C%20tense%20mood%2C%20spotlight%20on%20empty%20chair&width=1600&height=900&seq=article-hero-11&orientation=landscape',
    date: '2026-07-02',
    views: '456.2万',
    comments: '22.8万',
    featured: true,
  },
  {
    id: '12',
    title: '顶流歌手新歌被指抄袭海外作品，作曲者连夜发文回应',
    slug: 'singer-song-plagiarism',
    category: 'star-scandal',
    categoryName: '明星翻车现场',
    excerpt: '音乐专业人士对比分析发现，该歌曲副歌旋律与某海外歌手三年前的作品高度相似，相似度超过80%。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Music%20studio%20with%20mixing%20console%20and%20sheet%20music%2C%20creative%20atmosphere%2C%20warm%20studio%20lighting%2C%20professional%20audio%20equipment%2C%20artistic%20workspace%2C%20comparison%20of%20two%20music%20scores%20side%20by%20side&width=1600&height=900&seq=article-hero-12&orientation=landscape',
    date: '2026-07-01',
    views: '178.5万',
    comments: '6.9万',
    featured: false,
  },
];

export const mockComments = [
  {
    id: 'c1',
    articleId: '1',
    username: '吃瓜不嫌事大',
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20modern%20anime%20style%20avatar%20portrait%2C%20young%20person%2C%20simple%20clean%20background%2C%20soft%20colors%2C%20digital%20art&width=80&height=80&seq=avatar-01&orientation=squarish',
    comment: '哈哈哈果然是人设崩塌的一天，这种瓜我能吃一个月！',
    level: '资深瓜友',
    likes: 2391,
    date: '2026-07-07',
  },
  {
    id: 'c2',
    articleId: '1',
    username: '八卦研究中心',
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20cartoon%20avatar%20with%20glasses%2C%20smart%20expression%2C%20clean%20design%2C%20warm%20tones%2C%20digital%20illustration%20style&width=80&height=80&seq=avatar-02&orientation=squarish',
    comment: '坐等工作室发声明，看看这次又是什么说辞，估计又是"只是朋友"。',
    level: '认证瓜友',
    likes: 1862,
    date: '2026-07-07',
  },
  {
    id: 'c3',
    articleId: '1',
    username: '前排吃瓜群众',
    avatar: 'https://readdy.ai/api/search-image?query=Fun%20colorful%20avatar%20character%2C%20happy%20expression%2C%20vibrant%20colors%2C%20modern%20illustration%2C%20simple%20background&width=80&height=80&seq=avatar-03&orientation=squarish',
    comment: '51吃瓜果然从不让人失望，这料够劲爆！前排留名。',
    level: '钻石瓜友',
    likes: 3256,
    date: '2026-07-06',
  },
  {
    id: 'c4',
    articleId: '4',
    username: '明察秋毫小王',
    avatar: 'https://readdy.ai/api/search-image?query=Detective%20themed%20character%20avatar%2C%20magnifying%20glass%2C%20mysterious%20expression%2C%20dark%20warm%20colors%2C%20illustration%20style&width=80&height=80&seq=avatar-04&orientation=squarish',
    comment: '终于有人曝光选秀黑幕了！那些年的意难平选手终于有了答案。',
    level: '认证瓜友',
    likes: 4521,
    date: '2026-07-05',
  },
  {
    id: 'c5',
    articleId: '4',
    username: '娱乐圈纪检委',
    avatar: 'https://readdy.ai/api/search-image?query=Serious%20professional%20avatar%2C%20sharp%20expression%2C%20modern%20minimalist%20design%2C%20warm%20neutral%20colors%2C%20digital%20art&width=80&height=80&seq=avatar-05&orientation=squarish',
    comment: '这行业早该整顿了，支持曝光更多内幕！',
    level: '钻石瓜友',
    likes: 3876,
    date: '2026-07-05',
  },
  {
    id: 'c6',
    articleId: '4',
    username: '今日吃瓜bot',
    avatar: 'https://readdy.ai/api/search-image?query=Robot%20character%20avatar%2C%20cute%20sci-fi%20style%2C%20friendly%20expression%2C%20clean%20design%2C%20warm%20metallic%20colors&width=80&height=80&seq=avatar-06&orientation=squarish',
    comment: '已转发到各种群，这瓜必须让更多人看到。',
    level: '资深瓜友',
    likes: 2103,
    date: '2026-07-05',
  },
  {
    id: 'c7',
    articleId: '6',
    username: '音乐圈观察员',
    avatar: 'https://readdy.ai/api/search-image?query=Music%20lover%20avatar%20with%20headphones%2C%20artistic%20style%2C%20warm%20tones%2C%20creative%20expression%2C%20digital%20illustration&width=80&height=80&seq=avatar-07&orientation=squarish',
    comment: '技术分析我看了，确实存在严重的对口型问题，粉丝就别洗了。',
    level: '认证瓜友',
    likes: 5230,
    date: '2026-07-04',
  },
  {
    id: 'c8',
    articleId: '6',
    username: '真相只有一个',
    avatar: 'https://readdy.ai/api/search-image?query=Detective%20character%20avatar%2C%20magnifying%20glass%2C%20curious%20expression%2C%20cartoon%20style%2C%20warm%20colors%2C%20simple%20background&width=80&height=80&seq=avatar-08&orientation=squarish',
    comment: '开了这么多场演唱会，不会每场都假唱吧？细思极恐！',
    level: '资深瓜友',
    likes: 1765,
    date: '2026-07-04',
  },
  {
    id: 'c9',
    articleId: '9',
    username: '税法小达人',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20business%20avatar%2C%20confident%20expression%2C%20modern%20design%2C%20clean%20lines%2C%20warm%20professional%20colors&width=80&height=80&seq=avatar-09&orientation=squarish',
    comment: '又双叒叕一个网红被查，这些头部主播赚那么多还偷税，良心不会痛吗？',
    level: '钻石瓜友',
    likes: 6890,
    date: '2026-07-03',
  },
  {
    id: 'c10',
    articleId: '9',
    username: '吃瓜季军选手',
    avatar: 'https://readdy.ai/api/search-image?query=Trophy%20themed%20avatar%2C%20proud%20expression%2C%20gold%20accents%2C%20champion%20style%2C%20warm%20colors%2C%20digital%20art&width=80&height=80&seq=avatar-10&orientation=squarish',
    comment: '每次看到偷税漏税被查的新闻都特别解气！支持严查！',
    level: '认证瓜友',
    likes: 4120,
    date: '2026-07-03',
  },
  {
    id: 'c11',
    articleId: '11',
    username: '女性权益守护者',
    avatar: 'https://readdy.ai/api/search-image?query=Strong%20female%20character%20avatar%2C%20empowered%20expression%2C%20feminist%20theme%2C%20warm%20pastel%20colors%2C%20modern%20illustration&width=80&height=80&seq=avatar-11&orientation=squarish',
    comment: '五位女演员站出来发声需要巨大勇气，请大家给予尊重和支持！',
    level: '认证瓜友',
    likes: 12450,
    date: '2026-07-02',
  },
  {
    id: 'c12',
    articleId: '11',
    username: '正义也许会迟到',
    avatar: 'https://readdy.ai/api/search-image?query=Justice%20themed%20character%20avatar%2C%20serious%20expression%2C%20scale%20symbol%2C%20warm%20brown%20tones%2C%20digital%20art&width=80&height=80&seq=avatar-12&orientation=squarish',
    comment: '希望这次调查能给出公正结果，不要又不了了之了。',
    level: '钻石瓜友',
    likes: 8920,
    date: '2026-07-02',
  },
];

export const mockCategories = {
  'star-scandal': {
    slug: 'star-scandal',
    name: '明星翻车现场',
    description: '追踪娱乐圈明星翻车事件、人设崩塌、负面新闻等独家爆料内容。',
  },
  'influencer-gossip': {
    slug: 'influencer-gossip',
    name: '网红吃瓜',
    description: '关注网红圈最新动态、直播翻车、网红情侣八卦等热门话题。',
  },
  'black-material': {
    slug: 'black-material',
    name: '黑料入口',
    description: '深度曝光行业黑幕、明星黑历史、品牌解约内幕等重磅黑料。',
  },
};